<template>
    <div>
        <h2>{{name}}</h2>
    </div>
</template>
<script>
export default {
    props:{
        name:{
            type: String,
            required: true,
            default: ''
        }
    }
}
</script>

<style scoped>
h2{
    width: 85%;
    line-height: 35px;
    margin-bottom: 20px;
}

@media(max-width: 1025px){
    h2{
        width: 100%;
    }
}
</style>